module.exports = __webpack_public_path__ + "img/71.bfd50003.jpg";